/* unplugin-vue-components disabled */import script from "./teachTab.vue?vue&type=script&setup=true&lang=js"
export * from "./teachTab.vue?vue&type=script&setup=true&lang=js"

import "./teachTab.vue?vue&type=style&index=0&id=b94e06a4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b94e06a4"]])

export default __exports__